import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [ 
  {
    id: 'facturar-ticket',
    title: 'Facturar Ticket',
    type: 'item',
    icon: 'file-text',
    url:  'facturacion/facturar'    
  }/*,
  {
    id: 'consultar-factura',
    title: 'Consultar Factura',
    type: 'item',
    icon: 'external-link',
    url:  'facturacion/consultar'
  }
  /*,
  {
    id: 'promociones',
    title: 'Promociones',
    type: 'item',
    icon: 'gift',
    url:  'promociones'    
  }*/
]
